/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

// @mui material components
// @mui material components
// @mui icons
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import team1 from 'assets/images/avatar1.png';
import team2 from 'assets/images/avatar2.png';
import team3 from 'assets/images/avatar3.png';
import team4 from 'assets/images/avatar4.png';
// Images
import profile1 from 'assets/images/profile-1.png';
import profile2 from 'assets/images/profile-2.png';
import profile3 from 'assets/images/profile-3.png';
// Vision UI Dashboard React components
import VuiBox from 'components/VuiBox';
import VuiTypography from 'components/VuiTypography';
import ProfileInfoCard from 'examples/Cards/InfoCards/ProfileInfoCard';
import DefaultProjectCard from 'examples/Cards/ProjectCards/DefaultProjectCard';
import Footer from 'examples/Footer';
// Vision UI Dashboard React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
// Overview page components
import Header from 'layouts/pages/profile/profile-overview/components/Header/index';
import PlatformSettings from 'layouts/pages/profile/profile-overview/components/PlatformSettings/index';
import Welcome from 'layouts/pages/profile/profile-overview/components/Welcome/index';
import CarInformations from 'layouts/pages/profile/profile-overview/components/CarInformations/index';

function Overview() {
  return (
    <DashboardLayout>
      <Header />
      <VuiBox mt={5} mb={3}>
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            xl={4}
            xxl={3}
            sx={() => ({
              minHeight: '400px',
            })}
          >
            <Welcome />
          </Grid>
          <Grid item xs={12} xl={5} xxl={6}>
            <CarInformations />
          </Grid>
          <Grid item xs={12} xl={3} xxl={3}>
            <ProfileInfoCard
              title="profile information"
              description="Hi, I’m Mark Johnson, Decisions: If you can’t decide, the answer is no. If two equally difficult paths, choose the one more painful in the short term (pain avoidance is creating an illusion of equality)."
              info={{
                fullName: 'Mark Johnson',
                mobile: '(44) 123 1234 123',
                email: 'mark@simmmple.com',
                location: 'United States',
              }}
              social={[
                {
                  link: 'https://www.facebook.com/CreativeTim/',
                  icon: <FacebookIcon />,
                  color: 'facebook',
                },
                {
                  link: 'https://twitter.com/creativetim',
                  icon: <TwitterIcon />,
                  color: 'twitter',
                },
                {
                  link: 'https://www.instagram.com/creativetimofficial/',
                  icon: <InstagramIcon />,
                  color: 'instagram',
                },
              ]}
            />
          </Grid>
        </Grid>
      </VuiBox>
      <Grid container spacing={3} mb="30px">
        <Grid item xs={12} xl={3}>
          <PlatformSettings />
        </Grid>
        <Grid item xs={12} xl={9}>
          <Card>
            <VuiBox display="flex" flexDirection="column">
              <VuiTypography
                color="white"
                variant="lg"
                fontWeight="bold"
                mb="6px"
              >
                Projects
              </VuiTypography>
              <VuiTypography
                color="text"
                variant="button"
                fontWeight="regular"
                mb="24px"
              >
                Architects design houses
              </VuiTypography>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} xl={4}>
                  <DefaultProjectCard
                    image={profile1}
                    label="project #2"
                    title="modern"
                    description="As Uber works through a huge amount of internal management turmoil."
                    action={{
                      type: 'internal',
                      route: '/pages/profile/profile-overview',
                      color: 'white',
                      label: 'view all',
                    }}
                    authors={[
                      { image: team1, name: 'Elena Morison' },
                      { image: team2, name: 'Ryan Milly' },
                      { image: team3, name: 'Nick Daniel' },
                      { image: team4, name: 'Peterson' },
                    ]}
                  />
                </Grid>
                <Grid item xs={12} md={6} xl={4}>
                  <DefaultProjectCard
                    image={profile2}
                    label="project #1"
                    title="scandinavian"
                    description="Music is something that every person has his or her own specific opinion about."
                    action={{
                      type: 'internal',
                      route: '/pages/profile/profile-overview',
                      color: 'white',
                      label: 'view all',
                    }}
                    authors={[
                      { image: team3, name: 'Nick Daniel' },
                      { image: team4, name: 'Peterson' },
                      { image: team1, name: 'Elena Morison' },
                      { image: team2, name: 'Ryan Milly' },
                    ]}
                  />
                </Grid>
                <Grid item xs={12} md={6} xl={4}>
                  <DefaultProjectCard
                    image={profile3}
                    label="project #3"
                    title="minimalist"
                    description="Different people have different taste, and various types of music."
                    action={{
                      type: 'internal',
                      route: '/pages/profile/profile-overview',
                      color: 'white',
                      label: 'view all',
                    }}
                    authors={[
                      { image: team4, name: 'Peterson' },
                      { image: team3, name: 'Nick Daniel' },
                      { image: team2, name: 'Ryan Milly' },
                      { image: team1, name: 'Elena Morison' },
                    ]}
                  />
                </Grid>
              </Grid>
            </VuiBox>
          </Card>
        </Grid>
      </Grid>

      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
